import { useState } from 'react';
import {
    IDisclosuresActionsDetailsDto,
    IEnquiriesActionsDetailsDto,
    IRequestsUploadsActionsDetailListDto
} from '@vivli/features/dashboard/infrastructure/interface';
import { Subscription } from 'rxjs';
import { useCrossConcernsApiContext, useModalApiContext } from '@vivli/core/infrastructure/context';

export function useIndividualAwaitingActionsHook() {
    const modalService = useModalApiContext();
    const [requestsAndUploads, setRequestsAndUploads] = useState<IRequestsUploadsActionsDetailListDto | undefined>();
    const [disclosures, setDisclosures] = useState<IDisclosuresActionsDetailsDto | undefined>();
    const [enquiries, setEnquiries] = useState<IEnquiriesActionsDetailsDto | undefined>();

    const crossConcernsApi = useCrossConcernsApiContext();

    const handleFailure = (err: string) => {
        modalService.error(
            `An error occurred getting actions for the Dashboard. Please try again or contact Vivli support. Message: ${err}`
        );
    };

    const getRequestsAndUploads = (): Subscription | null => {
        if (!crossConcernsApi) return null;
        return crossConcernsApi.getRequestUploadActionDetails().subscribe({
            next: (res) => setRequestsAndUploads(res),
            error: (err) => handleFailure(err)
        });
    };

    const getDisclosures = (): Subscription | null => {
        if (!crossConcernsApi) return null;
        return crossConcernsApi.getDisclosureActionDetails().subscribe({
            next: (res) => setDisclosures(res),
            error: (err) => handleFailure(err)
        });
    };

    const getEnquiries = (): Subscription | null => {
        if (!crossConcernsApi) return null;
        return crossConcernsApi.getEnquiryActionDetails().subscribe({
            next: (res) => setEnquiries(res),
            error: (err) => handleFailure(err)
        });
    };

    return {
        requestsAndUploads,
        getRequestsAndUploads,
        getRequestsAndUploads$: () => crossConcernsApi?.getRequestUploadActionDetails(),
        disclosures,
        getDisclosures,
        enquiries,
        getEnquiries
    };
}
